// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__37dxY","title":"card_title__3n2rW","inActive":"card_inActive__zF6hI"};